const MESES_ABREV = ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"];

/**
 * Data da proxima parcela no detalhe da carteira — DD/Mmm/AAAA (cliente pediu a
 * data com dia).
 *
 * O MES/ANO vem da API (`proximaParcela`, YYYYMM), pela mesma regra do painel do
 * servidor. Antes saia de lancamento + parcelas pagas, e no legado o lancamento
 * e' a data da CARGA: um contrato de 31/96 carregado em 10/09/2026 aparecia com
 * proxima parcela em 10/Abr/2029, quando a proxima era outubro/2026 (#356).
 *
 * O DIA continua sendo o do lancamento (as parcelas caem no aniversario do
 * contrato), limitado ao ultimo dia do mes.
 */
export function proximaParcelaDetalhe(ct: {
  parcelasPagas: number;
  totalParcelas: number;
  lancamento: string;
  proximaParcela?: string | null;
}): string {
  if (ct.totalParcelas > 0 && ct.parcelasPagas >= ct.totalParcelas) return "Quitado";
  const comp = /^(\d{4})(\d{2})$/.exec(ct.proximaParcela ?? "");
  if (!comp) return "—";
  const ano = Number(comp[1]);
  const mes = Number(comp[2]) - 1;
  const lanc = /^(\d{2})\/\d{2}\/\d{4}$/.exec(ct.lancamento ?? "") ?? /^\d{4}-\d{2}-(\d{2})/.exec(ct.lancamento ?? "");
  const ultimoDia = new Date(ano, mes + 1, 0).getDate();
  const dia = Math.min(lanc ? Number(lanc[1]) : 1, ultimoDia);
  return `${String(dia).padStart(2, "0")}/${MESES_ABREV[mes]}/${ano}`;
}
